import { Spinner } from "@chakra-ui/spinner";

export const Loading = () => (
  <div className="flex items-center justify-center my-10">
    <Spinner size="lg" />
  </div>
);
